import {z} from 'zod';
import {SchemaValidationErrorLabel} from '@netx/core-next/schema';

// TODO: this is now just a shared resource
export const SavedCartSchema = z.object({
	id: z.number().int().positive(),
	canEdit: z.boolean(),
	canManage: z.boolean(),
	contentCount: z.number(),
	isFavorite: z.boolean(),
	participantCount: z.number().int().positive(),
	title: z.string().nonempty(SchemaValidationErrorLabel.REQUIRED),
});

export type ISavedCart = z.infer<typeof SavedCartSchema>;

export const SavedCartSchemaNew = SavedCartSchema.pick({
	title: true,
}).extend({
	id: z.number().int().nullable(),
});

/** a new saved cart map record */
export type ISavedCartNew = z.infer<typeof SavedCartSchemaNew>;

/** saved cart form values schema */
export const SavedCartFormSchema = SavedCartSchemaNew;
export type ISavedCartFormValues = z.infer<typeof SavedCartFormSchema>;
